import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-bn-info-notice',
  templateUrl: './bn-info-notice.component.html',
  styleUrls: ['./bn-info-notice.component.scss']
})
export class BnInfoNoticeComponent {
  hideAlert: boolean;

  constructor() { 
    this.hideAlert = false;
  }

  onClose() {
    this.hideAlert = true;
  }

}
